const formal = true; // 发布正式版改为true  测试版 false
const wxPay = {
  // 微信内支付
  appid: formal ? "wx56319ab0cbf4077b" : "wx56319ab0cbf4077b",
};
// const ip = formal ? "https://m.xzjy365.com" : "https://m.xzjy365.com"
const apiUrl = formal ? "https://m.xzjy365.com" : "http://192.168.1.53:6161"
// "http://192.168.1.166:8080"
// "https://mceshi.xzjy365.com"
const payUrl = formal ? "https://m.xzjy365.com" : "http://192.168.1.58:8080";
const QQBing = {
  // qq登录用到的信息
  appid: formal ? "101938255" : "101941950", // qq唯一id
  appKey: formal
    ? "a01c085f9f54004f4a8c491d8c95669a"
    : "905b123c21f243cd45581b249076d893", //
  redirectURI: formal
    ? "https://m.xzjy365.com/QQLogin"
    : "https://mceshi.xzjy365.com/QQLogin",
};
const wxLogin = {
  // 微信登录用到的信息
  appid: formal ? "wx56319ab0cbf4077b" : "wx56319ab0cbf4077b",
  scope: "snsapi_userinfo", // snsapi_userinfo    ||    snsapi_login
  self_redirect: false,
  redirect_uri: "http://mceshi.xzjy365.com",
  response_type: "code",
  state: "STATE#wechat_redirect",
  code: "",
  secret: "b8f600cfaaaee2aa6d73075930dd4df1",
};

export default {
  wxPay,
  formal,
  QQBing,
  wxLogin,
  payUrl,
  apiUrl
};
